import { Form, Link } from "@remix-run/react";
import { $path } from "remix-routes";
import { SocialLogin } from "~/components/auth/SocialLogin";
import { Button } from "~/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "~/components/ui/card";
import { Input } from "~/components/ui/input";
import { Label } from "~/components/ui/label";
import { cn } from "~/lib/utils/tailwind.util";

export type RegisterFormProps = {
  className?: string;
  enableGithub?: boolean;
  hasError?: boolean;
};

export function RegisterForm({
  className,
  enableGithub,
  hasError,
}: RegisterFormProps) {
  return (
    <Card className={cn("w-full max-w-sm", className)}>
      <CardHeader>
        <CardTitle className="text-2xl">Register</CardTitle>
        <CardDescription>
          Welcome! Please fill in the details to get started.
        </CardDescription>
      </CardHeader>
      <CardContent className="grid gap-4">
        <SocialLogin enableGithub={enableGithub} />

        <div className="flex items-center">
          <span className="flex-1 border-t"></span>
          <span className="m-4 text-sm text-muted-foreground">or</span>
          <span className="flex-1 border-t"></span>
        </div>

        {hasError && (
          <div className="rounded-md border border-red-500 bg-red-100 p-2 text-sm text-red-700">
            Register failed, please try again.
          </div>
        )}

        <Form method="POST" className="grid gap-4">
          <div className="grid gap-2">
            <Label htmlFor="name">Name</Label>
            <Input type="text" id="name" name="name" required />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="email">Email</Label>
            <Input type="email" id="email" name="email" required />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              name="password"
              type="password"
              autoComplete="new-password"
              required
            />
          </div>
          <Button type="submit" className="w-full">
            Register
          </Button>
        </Form>
        <div className="text-center text-sm text-muted-foreground">
          <p>
            Or login here:
            <Link to={$path("/login")}>
              <Button variant="link">Login</Button>
            </Link>
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
